import { g as getValueByPath, _ as _defineProperty } from './helpers-d639255d.js';
import { B as BaseComponentMixin, c as config, n as normalizeComponent, b as registerComponent, u as use } from './plugins-4295ce0e.js';
import './Icon-9c764942.js';
import './SlotComponent-11e2db3a.js';
import { T as TabbedMixin, a as TabbedChildMixin } from './TabbedChildMixin-ac90ce23.js';

/**
 * Responsive horizontal navigation tabs, switch between contents with ease
 * @displayName Tabs
 * @requires ./TabItem.vue
 * @example ./examples/Tabs.md
 * @style _tabs.scss
 */

var script = {
  name: 'OTabs',
  mixins: [BaseComponentMixin, TabbedMixin('tab')],
  props: {
    /**
     * Tab type
     * @values boxed, toggle
     */
    type: [String, Object],

    /**
    * Tabs will be expanded (full-width)	
    */
    expanded: Boolean,

    /** Tab will have an animation */
    animated: {
      type: Boolean,
      default: function _default() {
        return getValueByPath(config, 'tabs.animated', true);
      }
    },

    /** Show tab items multiline when there is no space */
    multiline: Boolean,
    rootClass: String,
    positionWrapperClass: String,
    expandedWrapperClass: String,
    verticalWrapperClass: String,
    multilineWrapperClass: String,
    tabsClass: String,
    typeClass: String,
    sizeClass: String,
    positionClass: String,
    contentClass: String,
    transitioningClass: String,
    tabItemHeaderActiveClass: String,
    tabItemHeaderDisabledClass: String
  },
  computed: {
    rootClasses: function rootClasses() {
      return [this.computedClass('tabs', 'rootClass', 'o-tabs-wrapper'), _defineProperty({}, "".concat(this.computedClass('tabs', 'positionWrapperClass', 'o-tabs-wrapper-position-')).concat(this.position), this.position && this.vertical), _defineProperty({}, this.computedClass('tabs', 'expandedWrapperClass', 'o-tabs-wrapper-fullwidth'), this.expanded), _defineProperty({}, this.computedClass('tabs', 'verticalWrapperClass', 'o-tabs-wrapper-vertical'), this.vertical), _defineProperty({}, this.computedClass('tabs', 'multilineWrapperClass', 'o-tabs-wrapper-multiline'), this.multiline)];
    },
    navClasses: function navClasses() {
      return [this.computedClass('tabs', 'tabsClass', 'o-tabs'), _defineProperty({}, "".concat(this.computedClass('tabs', 'typeClass', 'o-tabs-')).concat(this.type), this.type), _defineProperty({}, "".concat(this.computedClass('tabs', 'sizeClass', 'o-size-')).concat(this.size), this.size), _defineProperty({}, "".concat(this.computedClass('tabs', 'positionClass', 'o-tabs-position-')).concat(this.position), this.position && !this.vertical)];
    },
    contentClasses: function contentClasses() {
      return [this.computedClass('tabs', 'contentClass', 'o-tab-content'), _defineProperty({}, this.computedClass('tabs', 'transitioningClass', 'o-tab-content-transitioning'), this.isTransitioning)];
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { class: _vm.rootClasses }, [
    _c("nav", { class: _vm.navClasses }, [
      _c(
        "ul",
        _vm._l(_vm.items, function(childItem) {
          return _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: childItem.visible,
                  expression: "childItem.visible"
                }
              ],
              key: childItem.value,
              class: childItem.headerClasses
            },
            [
              childItem.$slots.header
                ? _c("o-slot-component", {
                    attrs: {
                      component: childItem,
                      name: "header",
                      tag: "button"
                    },
                    nativeOn: {
                      click: function($event) {
                        return _vm.childClick(childItem)
                      }
                    }
                  })
                : _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.childClick(childItem)
                        }
                      }
                    },
                    [
                      childItem.icon
                        ? _c("o-icon", {
                            attrs: {
                              icon: childItem.icon,
                              pack: childItem.iconPack,
                              size: _vm.size
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(childItem.label))])
                    ],
                    1
                  )
            ],
            1
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c("section", { class: _vm.contentClasses }, [_vm._t("default")], 2)
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

/**
 * @displayName Tab Item
 */

var script$1 = {
  name: 'OTabItem',
  mixins: [BaseComponentMixin, TabbedChildMixin('tab')],
  props: {
    /** Item will be disabled */
    disabled: Boolean,
    itemClass: String,
    itemHeaderActiveClass: String,
    itemHeaderDisabledClass: String
  },
  computed: {
    elementClasses: function elementClasses() {
      return [this.computedClass('tabs', 'itemClass', 'o-tab-item')];
    },
    headerClasses: function headerClasses() {
      return [this.headerClass, _defineProperty({}, this.computedClass('tabs', 'itemHeaderActiveClass', 'o-tab-active'), this.isActive), _defineProperty({}, this.computedClass('tabs', 'itemHeaderDisabledClass', 'o-tab-disabled'), this.disabled)];
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    {},
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, __vue_component__);
    registerComponent(Vue, __vue_component__$1);
  }
};
use(Plugin);

export default Plugin;
export { __vue_component__$1 as OTabItem, __vue_component__ as OTabs };
